import { render, staticRenderFns } from "./Properties_Comp.vue?vue&type=template&id=34fe8bd1&scoped=true&"
import script from "./Properties_Comp.vue?vue&type=script&lang=js&"
export * from "./Properties_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Properties_Comp.vue?vue&type=style&index=0&id=34fe8bd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fe8bd1",
  null
  
)

export default component.exports